import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMissedConnectionStep = (state) => state.get('missedConnectionStep');

const makeSelectMissedConnectionStep = () => createSelector(
  selectMissedConnectionStep,
  (selectMissedConnectionState) => ({

    // Trip MissedConnection
    travelMissedConnection: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'travelMissedConnection']),
      ''
    ),

    schoolNameForDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'schoolNameForDelay']),
      ''
    ),

    travelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'travelDelay']),
      ''
    ),

    detailsRegardingYourTripDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'detailsRegardingYourTripDelay']),
      ''
    ),

    companyNameTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'companyNameTravelDelay']),
      ''
    ),

    addressTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'addressTravelDelay']),
      ''
    ),

    cityTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'cityTravelDelay']),
      ''
    ),

    stateTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'stateTravelDelay']),
      ''
    ),

    zipCodeTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'zipCodeTravelDelay']),
      ''
    ),

    contactTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'contactTravelDelay']),
      ''
    ),

    phoneNumberTravelDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'phoneNumberTravelDelay']),
      ''
    ),

    includedInPackageForDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'includedInPackageForDelay']),
      ''
    ),

    dateOfInitialPaymentDeposit: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateOfInitialPaymentDeposit']),
      ''
    ),

    dateYouWereDueToDepart: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateYouWereDueToDepart']),
      ''
    ),

    timeYouWereDueToDepart: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'timeYouWereDueToDepart']),
      ''
    ),

    dateTripWasDelayed: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateTripWasDelayed']),
      ''
    ),

    dateDelayEnded: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateDelayEnded']),
      ''
    ),

    dateDelayEndedForDelay: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateDelayEndedForDelay']),
      ''
    ),

    dateTripWasDelayedWithTravelSupplier: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateTripWasDelayedWithTravelSupplier']),
      ''
    ),

    dateYouActuallyDeparted: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'dateYouActuallyDeparted']),
      ''
    ),

    timeYouActuallyDeparted: mapWithDefault(
      selectMissedConnectionState,
      () => selectMissedConnectionState.getIn(['form', 'timeYouActuallyDeparted']),
      ''
    ),

    companyNameLoss: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'enableTime']), null),
    lossInformationItems: mapWithDefault(selectMissedConnectionState, () => selectMissedConnectionState.getIn(['form', 'lossInformationItems']) && selectMissedConnectionState.getIn(['form', 'lossInformationItems']).toJS(), ''),
  })
);

const makeSelectMissedConnectionStepErrors = () =>
  createSelector(selectMissedConnectionStep, (state) => state.get('errors'));

export {
  makeSelectMissedConnectionStep,
  makeSelectMissedConnectionStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MissedConnectionStep/selectors.js